import { useCallback, useRef } from 'react';
import { focusNavCell } from '@/shared/ui/LinesGrid';

/**
 * Поле формы (или обёртка с полем внутри), на которое окно умеет переводить фокус по горячей
 * клавише (`Ctrl+↑` — «к шапке»). `attach` — ref-колбэк для элемента, `focus()` ставит курсор на
 * сам элемент или на первое доступное поле внутри; `false` — поставить некуда. Наружу отдаются
 * функции, а не `ref.current`, поэтому их безопасно использовать в обработчиках, создаваемых при
 * рендере (чтение `ref.current` прямо там запрещено правилами React).
 */
export function useFocusTarget<T extends HTMLElement = HTMLElement>(): { attach: (element: T | null) => void; focus: () => boolean } {
  const element = useRef<T | null>(null);
  const attach = useCallback((el: T | null) => {
    element.current = el;
  }, []);
  const focus = useCallback(() => focusNavCell(element.current), []);
  return { attach, focus };
}
